<template lang="pug">
  button.button.primary-button(type="submit", :class="classes", :disabled="isDisabled")
    font-awesome-icon.icon(v-if="state === 'pending'", :icon="['fad','spinner-third']", spin)
    font-awesome-icon.icon(v-if="state === 'success'", :icon="['fas','check']")
    span {{ label }}
</template>

<script>

export default {
  name: 'SubmitButton',
  components: {
  },
  props: {
    formState: {
      type: String,
      default: 'initial'
    },
    label: {
      type: String,
      default: 'Save'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    successLabel: {
      type: String,
      default: 'Saved'
    }
  },
  data () {
    return {
      state: this.formState
    }
  },
  computed: {
    classes () {
      let classes = []
      classes.push(this.state)
      return classes
    },
    isDisabled () {
      return this.disabled || this.state === 'pending'
    }
  },
  methods: {
  },
  watch: {
    formState: function (state) {
      this.state = state

      if (['success', 'error'].indexOf(state) > -1) {
        setTimeout(() => {
          this.state = 'initial'
          this.$emit('stateChange', 'initial')
        }, 2000)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  button.button
    padding $spacing $spacing-3
    text-align center
    &:disabled
      opacity .8
</style>
